module.exports = ".headerDisplay div {\n  text-overflow: clip;\n  overflow: visible;\n  white-space: normal; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/assorted/grid-header.component.scss
// module id = ./src/app/shared/components/assorted/grid-header.component.scss
// module chunks = main